<div class="dashboard-material-theme dashboard-release-note-dialog">
  <dashboard-dialog-title [title]="isEdit ? 'Edit Release Note' : 'Create New Release Note'"></dashboard-dialog-title>
  <mat-dialog-content class="dashboard-release-note-dialog__content">
    <form
      [formGroup]="releaseNoteForm"
      fxLayout="column"
      dashboardConnectForm
      [connectForm]="isEdit ? data.releaseNote : null"
    >
      <mat-form-field appearance="fill">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Description</mat-label>
        <textarea
          class="dashboard-release-note-dialog__text-area"
          matInput
          rows="10"
          formControlName="description"
        ></textarea>
      </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="row" fxLayoutGap="15px">
        <span class="dashboard-release-note-dialog__tags">Tags: </span>
        <mat-chip-list multiple aria-label="Tag selection">
          <mat-chip [selected]="tags.updates" color="accent" (click)="updateUpdates()">Updates</mat-chip>
          <mat-chip [selected]="tags.regular" color="accent" (click)="updateTiim()">TIIM</mat-chip>
          <mat-chip [selected]="tags.careercompass" color="accent" (click)="updateCC()">Career compass</mat-chip>
        </mat-chip-list>
      </div>
      <mat-chip color="accent" selected (click)="submitReleaseNote()">Send</mat-chip>
    </div>
  </mat-dialog-content>
</div>
